import { useNuxtApp } from '#imports';

enum QueryEvmKey {
    WATCH_LISTS = 'watch_lists',
    SEARCH_COLLECTIONS = 'search_collections',
    SEARCH_NFTS = 'search_nfts',
    NFT = 'nft_get',
    NFT_BY_ADDRESS = 'nft_by_address',
    NFT_LIST = 'nft_list',
    NFT_LITE = 'nft_lite',
    WETH_BALANCE = 'weth_balance',
    USER_BALANCE = 'user_balance',
    OPEN_SEA_FEES = 'open_sea_fees',
    OFFER_LIST = 'offer_list',
    OFFER_MADE_LIST = 'offer_made_list',
    OFFER_RECEIVE_LIST = 'offer_receive_list',
    COMMISSION_BY_SLUG = 'commission_by_slug',
    MARKETPLACE_CONTRACTS = 'marketplace_contracts',
    COLLECTION_APPROVED_TOKENS = 'collect_app_approved_tokens',
    DROP = 'wtf_drop_info',
    DROPS_LIST = 'wtf_drop_list',
    ORDER_LIST = 'wtf_order_list'
}

export default function useEVMApi() {
    const { $evmApi } = useNuxtApp();

    if (!$evmApi) {
        throw new Error('evmApi not provided from root app!');
    }
    return {
        ...$evmApi,
        QueryEvmKey
    };
}
